var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M4.09 12.6699C4.2 13.0649 4.405 13.4199 4.675 13.7099L0.955002 16.6549C0.845002 16.7449 0.715001 16.7849 0.595001 16.7849C0.290001 16.7849 0 16.5449 0 16.1949C0 16.0149 0.0799985 15.8449 0.224998 15.7299L4.09 12.6699Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M8.935 12.5698L13.59 16.0798C13.3 16.3648 13.1 16.7398 13.03 17.1598L8.375 13.6498C8.645 13.3448 8.84 12.9748 8.935 12.5698Z",
    fill: "#D0D7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M20.0004 14.2697V14.2997C20.0004 14.4847 19.9154 14.6547 19.7654 14.7697L16.9153 16.9147C16.7903 16.5197 16.5554 16.1747 16.2354 15.9247L19.0553 13.7997C19.4453 13.5097 20.0004 13.7847 20.0004 14.2697Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M8.2498 4.6998H3.2498C2.8648 4.6998 2.5498 4.3848 2.5498 3.9998C2.5498 3.6148 2.8648 3.2998 3.2498 3.2998H8.2498C8.6348 3.2998 8.9498 3.6148 8.9498 3.9998C8.9498 4.3848 8.6348 4.6998 8.2498 4.6998Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M10.2498 7.4498H3.2498C2.8648 7.4498 2.5498 7.1348 2.5498 6.7498C2.5498 6.3648 2.8648 6.0498 3.2498 6.0498H10.2498C10.6348 6.0498 10.9498 6.3648 10.9498 6.7498C10.9498 7.1348 10.6348 7.4498 10.2498 7.4498Z",
    fill: "#AFB8C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M9 12C9 12.195 8.975 12.385 8.935 12.57C8.84 12.975 8.645 13.345 8.375 13.65C7.92 14.17 7.25 14.5 6.5 14.5C5.75 14.5 5.135 14.195 4.675 13.71C4.405 13.42 4.2 13.065 4.09 12.67C4.03 12.455 4 12.23 4 12C4 10.62 5.12 9.5 6.5 9.5C7.88 9.5 9 10.62 9 12Z",
    fill: "#AFB8C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M17 17.5C17 18.605 16.105 19.5 15 19.5C13.895 19.5 13 18.605 13 17.5C13 17.385 13.01 17.27 13.03 17.16C13.1 16.74 13.3 16.365 13.59 16.08C13.955 15.725 14.45 15.5 15 15.5C15.46 15.5 15.89 15.66 16.23 15.925C16.55 16.175 16.785 16.52 16.91 16.915C16.965 17.1 16.995 17.295 16.995 17.5H17Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineTop);
export default __webpack_public_path__ + "static/media/line-top.87aa7c54a7a9024094fc5b2a9ad46929.svg";
export { ForwardRef as ReactComponent };